<template>
  <div style="display: inline" class="text-xs-left">
    <template
      v-if="
        ((loadingProduct || loadingCategory) &&
          $store.state.shoptheme.includes(selectedBot.theme)) ||
        loadingSetting
      "
    >
      <div class="text-xs-center">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
    </template>
    <a
      href="javascript:void(0);"
      @click="onEditGenericButton"
      style="padding: 15px 0; display: inline"
      v-else
    >
      <slot name="body">Link</slot>
    </a>

    <div
      v-if="isEdit"
      style="position: absolute; top: 0px"
      :style="{ right: right ? right : '-45px' }"
    >
      <div style="display: flex">
        <v-menu offset-y open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn class="extra-small" color="primary" fab outline v-on="on">
              <v-icon small>build</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-tile @click="onEditGenericButton">
              <v-list-tile-title class="primary-color">{{ $t('edit') }}</v-list-tile-title>
            </v-list-tile>
            <slot name="append"> </slot>
          </v-list>
        </v-menu>
      </div>
    </div>

    <v-dialog v-model="showModal" persistent max-width="600px">
      <v-card>
        <div class="text-xs-right">
          <v-spacer></v-spacer>
          <v-btn flat icon small fab @click="onClose">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <div v-if="button && showModal">
            <label for="name" class="caption">{{ $t('If customer clicks') }}</label>
            <div class="form-control" :class="{ 'has-error': errors.has('buttonName') }">
              <input
                type="text"
                class="form-control"
                v-model="title"
                maxlength="20"
                name="buttonName"
                :data-vv-as="$t('Button Name')"
                :placeholder="$t('Button Name')"
                v-validate="'required'"
                @blur="onTypeTitle(title)"
              />
              <v-layout wrap>
                <v-flex xs11 class="error--text">
                  {{ errors.first('buttonName') }}
                </v-flex>
                <v-flex xs1 class="text-xs-right caption grey--text">
                  {{ title.length }}/20
                </v-flex>
              </v-layout>
            </div>

            <v-tabs
              v-model="state"
              color="white"
              :slider-color="$vuetify.theme.primary"
              @change="onChangeType"
            >
              <v-tab :key="'link'" :href="'#link'" ripple>
                <em class="fas fa-link" />
                <span style="margin-left: 5px">{{ $t('Link') }}</span>
              </v-tab>
              <v-tab :key="'text'" :href="'#text'" ripple>
                <em class="fas fa-align-left" />
                <span style="margin-left: 5px">{{ $t('Text') }}</span>
              </v-tab>
              <v-tab :key="'call'" :href="'#call'" ripple>
                <em class="fas fa-phone" />
                <span style="margin-left: 5px">{{ $t('Tel') }}</span>
              </v-tab>
              <template v-if="$store.state.shoptheme.includes(selectedBot.theme) && showShopLink">
                <v-tab
                  :key="'shop'"
                  :href="'#shop'"
                  ripple
                  :class="{ 'not-active': products.length == 0 }"
                >
                  <em class="fas fa-shopping-basket" />
                  <span style="margin-left: 5px">{{ $t('Shop Service') }}</span>
                </v-tab>
              </template>

              <template v-if="showBroadcast">
                <v-tab :key="'broadcast'" :href="'#broadcast'" ripple>
                  <v-icon>link</v-icon>
                  <span style="margin-left: 5px">{{ $t('Broadcast') }}</span>
                </v-tab>
              </template>

              <v-tabs-items touchless style="margin-top: 15px">
                <div :key="'link'" v-if="state == 'link'">
                  <div class="row" v-if="state == 'link'">
                    <div class="col s12">
                      <div style="margin-bottom: 15px">
                        {{
                          $t(
                            'When customer clicks this button, bot will automatically take customer to this link'
                          )
                        }}
                      </div>
                      <div style="margin-bottom: 15px">
                        {{ $t('* Only use https: // or http://') }}
                      </div>
                      <label for="link" class="caption">{{ $t('Link') }}</label>
                    </div>
                    <div
                      class="col s12 form-control"
                      :class="{ 'has-error': errors.has('buttonLink') }"
                    >
                      <textarea
                        name="buttonLink"
                        key="button-link"
                        :data-vv-name="'buttonLink'"
                        rows="10"
                        class="form-control"
                        style="width: 100%; resize: vertical"
                        v-model="url"
                        :data-vv-as="$t('Link')"
                        v-validate="state == 'link' ? 'required|isUrl' : ''"
                        placeholder="https://www.website.com"
                      ></textarea>
                      <span class="text-error" v-show="errors.has('buttonLink')">
                        {{ errors.first('buttonLink') }}
                      </span>
                    </div>
                  </div>
                </div>

                <div :key="'text'" v-if="state == 'text'">
                  <div style="margin-bottom: 20px">
                    {{
                      $t(
                        'If customer clicks this button, it will send this message to your customer (you can edit the answer in conversation page)'
                      )
                    }}
                  </div>
                  <div class="text-xs-center" v-if="state == 'text'">
                    <a
                      href="javascript:void(0);"
                      class="btn-advanced"
                      @click="showAdvanced = !showAdvanced"
                    >
                      {{ $t('Advanced') }}
                      <em
                        class="fa"
                        :class="{ 'fa-angle-down': showAdvanced, 'fa-angle-up': !showAdvanced }"
                      />
                    </a>
                  </div>
                  <div class="row" v-show="showAdvanced" style="margin-top: 15px">
                    <div class="col s12">
                      <label for="link" class="caption">Action</label>
                    </div>
                    <div
                      class="col s12 form-control"
                      :class="{ 'has-error': errors.has('buttonPayload') }"
                    >
                      <input
                        type="text"
                        name="buttonPayload"
                        key="button-payload"
                        :data-vv-name="'buttonPayload'"
                        rows="5"
                        maxlength="1000"
                        class="form-control"
                        style="width: 100%; resize: none"
                        v-model="payload"
                        data-vv-as="Text"
                        v-validate="state == 'text' ? 'required' : ''"
                        placeholder="Type action"
                      />
                      <v-layout>
                        <v-flex class="error--text">
                          {{ errors.first('buttonPayload') }}
                        </v-flex>
                        <v-flex shrink class="text-xs-right caption grey--text">
                          {{ payload.length }}/1000
                        </v-flex>
                      </v-layout>
                    </div>
                  </div>
                </div>

                <div :key="'call'" v-if="state == 'call'">
                  <div class="row" v-if="state == 'call'">
                    <div class="col s12">
                      <div style="margin-bottom: 15px">
                        {{
                          $t(
                            'When customer clicks this button, Bot will automatically call to the given phone number.'
                          )
                        }}
                      </div>
                      <p>{{ $t('*This function will only work when user use mobile phone.') }}</p>
                      <label for="phone_number" class="caption">{{ $t('Tel') }}</label>
                    </div>
                    <div
                      class="col s12 form-control"
                      :class="{ 'has-error': errors.has('phone') || errorTel }"
                    >
                      <input
                        v-model="call"
                        name="phone"
                        type="text"
                        :key="'tel_' + editTimestamp"
                        v-validate="{
                          required: true,
                          regex: /^[+]{1}[1-9]{1}[0-9]{0,2}[1-9]{1}[0-9]{7,8}$|^[0-9]{3,4}$/
                        }"
                      />
                      <div class="caption grey--text">Ex. +66812345678 or 123 or 1678</div>
                      <span class="text-error" v-if="errors.has('phone')">{{
                        errors.first('phone')
                      }}</span>
                    </div>
                  </div>
                </div>

                <template v-if="$store.state.shoptheme.includes(selectedBot.theme)">
                  <div :key="'shop'" :value="'shop'" v-if="state == 'shop'">
                    <p>
                      {{
                        $t(
                          'When customer clicks this button, Bot will take customer to Shop-Service.'
                        )
                      }}
                    </p>
                    <div
                      class="row warning-message left-align"
                      style="margin: 0; margin-bottom: 15px"
                      v-if="products.length == 0"
                    >
                      <div style="display: flex">
                        <vue-simple-svg
                          :filepath="'/static/img/assets/_global/warning.svg'"
                          width="30px"
                          height="auto"
                          class="icon"
                        />
                        <div style="padding-left: 10px">
                          <div class="strong" style="margin-bottom: 10px">{{ $t('Warning!') }}</div>
                          {{
                            $t(
                              'please add product in Shop-Service, if you want to use this feature'
                            )
                          }}
                        </div>
                      </div>
                    </div>
                    <div :style="{ 'min-height': expandForSelect ? '300px' : '' }">
                      <multiselect
                        class="mb-2"
                        v-model="category"
                        :options="categoryOptions"
                        label="label"
                        :allow-empty="false"
                        selectLabel
                        selectedLabel
                        deselect-label
                        track-by="label"
                        @select="onSelectCateogry"
                        :maxHeight="250"
                        @open="expandForSelect = true"
                        @close="expandForSelect = false"
                        :openDirection="'below'"
                        :key="'category_' + editTimestamp"
                      ></multiselect>

                      <multiselect
                        v-model="product"
                        :options="filterProducts"
                        label="label"
                        selectLabel
                        selectedLabel
                        :placeholder="$t('Products')"
                        track-by="label"
                        @select="onSelectProduct"
                        :maxHeight="250"
                        @open="expandForSelect = true"
                        @close="expandForSelect = false"
                        :openDirection="'below'"
                        :key="'product_' + editTimestamp"
                        :loading="loading"
                      ></multiselect>
                    </div>
                  </div>

                  <div :key="'transfer'" v-if="state == 'transfer'">
                    <p>{{ $t('Redirect customer to Cash Transfer page') }}</p>
                    <div
                      class="row warning-message left-align"
                      style="margin: 0; margin-bottom: 15px"
                      v-if="
                        setting &&
                        setting.allowtransfer &&
                        setting.allowtransfer.contentvalue == false
                      "
                    >
                      <div style="display: flex">
                        <vue-simple-svg
                          :filepath="'/static/img/assets/_global/warning.svg'"
                          width="30px"
                          height="auto"
                          class="icon"
                        />
                        <div style="padding-left: 10px">
                          <div class="strong" style="margin-bottom: 10px">{{ $t('Warning!') }}</div>
                          {{ $t('you have not opened Bank Transfer in Shop-Service') }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div :key="'credit_card'" v-if="state == 'credit_card'">
                    <p>{{ $t('Redirect customer to Credit Card payment page') }}</p>

                    <div
                      class="row warning-message left-align"
                      style="margin: 0; margin-bottom: 15px"
                      v-if="
                        setting && setting.allowcreditcard && selectedBot.paypal_merchantid == null
                      "
                    >
                      <div style="display: flex">
                        <vue-simple-svg
                          :filepath="'/static/img/assets/_global/warning.svg'"
                          width="30px"
                          height="auto"
                          class="icon"
                        />
                        <div style="padding-left: 10px">
                          <div class="strong" style="margin-bottom: 10px">{{ $t('Warning!') }}</div>
                          {{
                            $t(
                              'You havent registered credit card payment. Go to Setting page to Link PayPal Account for chatbot.'
                            )
                          }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="row warning-message left-align"
                      style="margin: 0; margin-bottom: 15px"
                      v-else-if="
                        setting &&
                        setting.allowcreditcard &&
                        setting.allowcreditcard.contentvalue == false
                      "
                    >
                      <div style="display: flex">
                        <vue-simple-svg
                          :filepath="'/static/img/assets/_global/warning.svg'"
                          width="30px"
                          height="auto"
                          class="icon"
                        />
                        <div style="padding-left: 10px">
                          <div class="strong" style="margin-bottom: 10px">{{ $t('Warning!') }}</div>
                          {{ $t('you have not opened Credit card in Shop-Service') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <div :key="'broadcast'" v-if="state == 'broadcast'" class="text-xs-center">
                  <v-btn
                    @click="payload = 'subscribeBroadcast'"
                    :outline="payload != 'subscribeBroadcast'"
                    depressed
                    :color="payload == 'subscribeBroadcast' ? 'primary' : 'grey'"
                    :class="{ 'v-btn--active': payload == 'subscribeBroadcast' }"
                  >
                    <v-icon class="pr-2">link</v-icon>
                    <span>{{ $t('Subscribe') }}</span>
                  </v-btn>
                  <v-btn
                    @click="payload = 'unsubscribeBroadcast'"
                    :outline="payload != 'unsubscribeBroadcast'"
                    depressed
                    :color="payload == 'unsubscribeBroadcast' ? 'primary' : 'grey'"
                    :class="{ 'v-btn--active': payload == 'unsubscribeBroadcast' }"
                  >
                    <v-icon class="pr-2">link_off</v-icon>
                    <span>{{ $t('Unsubscribe') }}</span>
                  </v-btn>
                  <input
                    type="hidden"
                    v-model="payload"
                    v-validate="'required'"
                    name="broadcastPayload"
                    :data-vv-as="$t('Broadcast')"
                  />
                  <div class="text-xs-center error--text" v-if="errors.has('broadcastPayload')">
                    {{ errors.first('broadcastPayload') }}
                  </div>
                </div>
              </v-tabs-items>
            </v-tabs>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" outline @click="onClose">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" depressed @click="onSave">{{ $t('Save') }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import ModalDialog from '@/components/elements/ModalDialog'
import TelInput from '@/components/elements/TelInput'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'
import { mapGetters } from 'vuex'
export default {
  props: {
    value: {
      default: undefined
    },
    isEdit: {
      default: false
    },
    right: {
      default: undefined
    },
    showShopLink: {
      default: true,
      type: Boolean
    },
    showBroadcast: {
      default: true,
      type: Boolean
    }
  },

  data: function () {
    return {
      showModal: false,
      button: {
        title: '',
        type: '',
        payload: '',
        url: ''
      },
      title: '',
      call: '',
      url: '',
      payload: '',
      showAdvanced: false,
      state: 'link',
      type: 'link',
      product: null,
      errorTel: false,
      category: {
        label: 'All',
        value: 'all'
      },
      expandForSelect: false,
      editTimestamp: moment().format('x'),
      productListBySlug: [],
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang',
      products: 'getProducts',
      loadingProduct: 'getLoadingProduct',
      loadingSetting: 'getLoadingSetting',
      setting: 'getSetting',
      categories: 'getCategories',
      loadingCategory: 'getLoadingCategory'
    }),
    categoryOptions: function () {
      var categories = [
        {
          label: 'All',
          value: 'all'
        },
        {
          label: 'Sales',
          value: 'sales'
        }
      ]
      if (!this.loadingCategory) {
        if (this.categories) {
          if (this.$store.state.thailandPostmartPage.includes(this.selectedBot.pageid)) {
            var categories = []
            this.category = {
              label: 'สินค้าทั้งหมด',
              value: 'all'
            }
            this.categories.map(function (category) {
              categories.push({ label: category.title, value: category.slug })
            })
          } else {
            this.categories.map(function (category) {
              categories.push({ label: category.name, value: category.id })
            })
          }
        }
      }
      return categories
    },
    currentType: function () {
      var vm = this
      if (this.button.type === 'web_url') {
        if (this.button.url.includes('{shopurl}')) {
          var category = vm.button.url.split('&category=')
          if (category.length > 1) {
            vm.category = vm.categoryOptions.find(function (value, index) {
              return value.id === category[1]
            })
          } else {
            vm.category = vm.categoryOptions[0]
          }
          return 'shopurl'
        } else if (this.button.url === '{transferurl}') {
          return 'transferurl'
        } else if (this.button.url === '{creditcardurl}') {
          return 'creditcardurl'
        } else if (this.button.url === '{viewsummary}') {
          return 'viewsummary'
        } else {
          return 'web_url'
        }
      } else if (this.button.type === 'postback') {
        return 'postback'
      } else if (this.button.type === 'phone_number') {
        return 'phone_number'
      } else {
        return ''
      }
    },
    filterProducts: function () {
      let products = []
      let vm = this

      if (this.$store.state.thailandPostmartPage.includes(this.selectedBot.pageid)) {
        if (vm.category && vm.category.value === 'all') {
          products = vm.products
        } else {
          products = vm.productListBySlug
        }
        var p = []
        if (products) {
          products.map((product) => {
            p.push({ label: product.product_title, value: product.sku })
          })
        }
      } else {
        if (vm.category && vm.category.value === 'all') {
          products = vm.products
        } else if (vm.category && vm.category.value === 'sales') {
          var isDiscount = false
          products = vm.products.filter((product) => {
            if (parseFloat(product.price) !== parseFloat(product.discountprice)) {
              return true
            } else {
              if (product.productstock) {
                product.productstock.map(function (stock, sindex) {
                  if (parseFloat(stock[3]) > parseFloat(stock[4])) {
                    isDiscount = true
                    return true
                  }
                })
              }
            }
            return false
          })
        } else {
          products = vm.products.filter((product) => {
            var isFoundSkuInStock = false
            return product.categoryid == vm.category.value
          })
        }

        var p = []
        if (products) {
          products.map((product) => {
            p.push({ label: product.name, value: product.id })
          })
        }
      }

      return p
    }
  },
  components: {
    ModalDialog,
    VueTelInput,
    Multiselect,
    TelInput
  },
  created: function () {
    var vm = this

    // vm.getSetting(function(contents) {
    //   vm.$store.dispatch('updateSetting', contents)
    // })
    vm.reset()
  },
  methods: {
    getParameterByName(name, url) {
      if (!url) url = window.location.href
      name = name.replace(/[\[\]]/g, '\\$&')
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url)
      if (!results) return null
      if (!results[2]) return ''
      return decodeURIComponent(results[2].replace(/\+/g, ' '))
    },
    async onEditGenericButton() {
      var vm = this
      if (this.$store.state.shoptheme.includes(vm.selectedBot.theme)) {
        if (vm.button.type === 'web_url' && vm.button.url.includes('{shopurl}')) {
          var category = vm.getParameterByName('category', vm.button.url)
          if (category != null) {
            if (vm.$store.state.thailandPostmartPage.includes(vm.selectedBot.pageid)) {
              await vm.getProductBySlugThailandPostmart(category)
            }
            vm.category = vm.categoryOptions.find(function (value, index) {
              return value.value == category
            })
            if (!vm.category) {
              vm.category = vm.categoryOptions[0]
            }
          } else {
            vm.category = vm.categoryOptions[0]
          }

          var product = vm.getParameterByName('pid', vm.button.url)
          if (product != null) {
            vm.product = vm.filterProducts.find(function (value, index) {
              return value.value == product
            })
            if (!vm.product) {
              vm.product = vm.filterProducts[0]
            }
          } else {
            vm.product = null
          }
        }
      }
      vm.reset()
      vm.showModal = true
    },
    onSelectCateogry: function (category) {
      var vm = this
      if (vm.$store.state.shoptheme.includes(vm.selectedBot.theme)) {
        vm.product = null
      }
      if (vm.$store.state.thailandPostmartPage.includes(vm.selectedBot.pageid)) {
        vm.getProductBySlugThailandPostmart(category.value)
      }
    },
    onSelectProduct: function () {},
    onInput({ number, isValid, country }) {
      if (this.state === 'call') {
        this.errorTel = !isValid
      } else {
        this.errorTel = false
      }
    },

    onSave: function () {
      var vm = this
      var data = {
        title: vm.title
      }
      if (vm.state === 'call') {
        data.type = 'phone_number'
        data.payload = vm.call
      } else if (vm.state === 'text') {
        data.type = 'postback'
        data.payload = vm.payload
      } else if (vm.state === 'link') {
        data.type = 'web_url'
        data.url = vm.url
      } else if (vm.state === 'shop') {
        data.type = 'web_url'
        data.url = '{shopurl}&category=' + vm.category.value

        if (vm.product) {
          data.url += '&pid=' + vm.product.value
        }
      } else if (vm.state === 'transfer') {
        data.type = 'web_url'
        data.url = '{transferurl}'
      } else if (vm.state === 'credit_card') {
        data.type = 'web_url'
        data.url = '{creditcardurl}'
      } else if (vm.state === 'broadcast') {
        data.type = 'postback'
        data.payload = vm.payload
      }
      if (this.errorTel) {
        return false
      }

      vm.$validator.validate().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }

        vm.cache_button = JSON.stringify(data)
        vm.showModal = false
        vm.$emit('onSave', data)
        vm.reset()
      })
    },
    onClose: function () {
      this.button = JSON.parse(this.cache_button)
      this.showModal = false
      // this.clearField()
    },
    onChangeType: function () {
      if (this.state === 'text') {
        if (this.payload === '') {
          this.payload = this.title
        }
      }
      if (this.state !== 'call') {
        this.errorTel = false
      }
      this.errors.clear()
    },
    onTypeTitle: function (text) {
      var vm = this
      if (vm.state === 'text') {
        vm.$nextTick(function () {
          vm.payload = text
        })
      }
    },
    getCategories: function (callback) {
      let vm = this
      return new Promise(async (resolve, reject) => {
        if (vm.$store.state.thailandPostmartPage.includes(vm.selectedBot.pageid)) {
          api.getCategoriesThailandPostmart(
            { pageid: vm.selectedBot.pageid },
            function (error, response) {
              if (error) {
                reject(error)
                return
              }
              var categorylist = response.data
              if (categorylist) {
                categorylist.map(function (category, index) {
                  vm.categoryOptions.push({
                    label: category.title,
                    value: category.slug
                  })
                })
              }
              resolve()
            }
          )
        } else {
          var data = {
            pageid: vm.selectedBot.pageid
          }
          if (
            vm.selectedBot.useketshop == true &&
            vm.selectedBot.ketshop_api_key &&
            vm.selectedBot.ketshop_api_secret
          ) {
            data['ketshop_api_key'] = vm.selectedBot.ketshop_api_key
            data['ketshop_api_secret'] = vm.selectedBot.ketshop_api_secret
          }
          api.getCategories(data, function (error, response) {
            if (error) {
              console.error(error)
              reject(error)
            }
            var categorylist = response.categorylist
            if (categorylist) {
              categorylist.map(function (category, index) {
                vm.categoryOptions.push({
                  label: category.name,
                  value: category.id
                })
              })
            }
            resolve()
          })
        }
      })
    },
    async getProductBySlugThailandPostmart(slug) {
      var vm = this
      return new Promise(async (resolve, reject) => {
        let data = {
          slug: slug,
          pageid: vm.selectedBot.pageid
        }
        vm.loading = true
        await api.getProductBySlugThailandPostmart(data, function (error, response) {
          if (error) {
            reject(error)
            return
          }
          var productlist = response.data
          if (productlist) {
            vm.productListBySlug = productlist
            vm.loading = false
          }
          resolve()
        })
      })
    },
    clearField: function () {
      var vm = this
      vm.state = 'link'
      vm.button = {
        title: '',
        type: '',
        payload: '',
        url: ''
      }
      vm.title = ''
      vm.call = ''
      vm.url = ''
      vm.payload = ''
      vm.errorTel = false
    },
    reset: function () {
      var vm = this
      vm.clearField()
      this.errors.clear()
      this.$forceUpdate()
      this.editTimestamp = moment().format('x')

      this.button = Object.assign({}, this.value)
      this.cache_button = JSON.stringify(this.value)

      vm.title = vm.button.title

      if (vm.button.type === 'phone_number') {
        vm.call = vm.button.payload
        vm.state = 'call'
      } else if (vm.button.type === 'postback') {
        vm.payload = vm.button.payload
        if (['unsubscribeBroadcast', 'subscribeBroadcast'].includes(vm.button.payload)) {
          vm.state = 'broadcast'
        } else {
          vm.state = 'text'
        }
        if (vm.button.title !== vm.button.payload) {
          vm.showAdvanced = true
        }
      } else if (vm.button.type === 'web_url' && vm.button.url.includes('{shopurl}')) {
        var category = vm.button.url.split('&category=')[1].split('&')[0]
        if (category.length > 1) {
          vm.category = vm.categoryOptions.find(function (value, index) {
            return value.value == category
          })
          if (!vm.category) {
            vm.category = vm.categoryOptions[0]
          }
        } else {
          vm.category = vm.categoryOptions[0]
        }
        vm.state = 'shop'
      } else if (vm.button.type === 'web_url' && vm.button.url === '{transferurl}') {
        vm.state = 'transfer'
      } else if (vm.button.type === 'web_url' && vm.button.url === '{creditcardurl}') {
        vm.state = 'credit_card'
      } else if (vm.button.type === 'web_url') {
        vm.url = vm.button.url
        vm.state = 'link'
      }
    }
  },
  watch: {
    value: function () {
      var vm = this
      vm.reset()
    },
    loadingProduct: function () {},
    loadingCategory: function () {}
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/chatbot/AddGenericButton.vue